import { __rest } from 'tslib';
import React from 'react';
import { extractMarginProps, extractPaddingProps, extractDimensionProps } from '@10d/tend-ui-styling';
import { useColor } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const levels = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    d1: 'h1',
    d2: 'h2',
};
const Title = React.forwardRef((_a, ref) => {
    var { level = 'h1', uppercase, color, textAlign, className, whiteSpace } = _a, props = __rest(_a, ["level", "uppercase", "color", "textAlign", "className", "whiteSpace"]);
    const _color = useColor(color);
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractPaddingProps(withoutMargins), { rest: withoutPaddings } = _c, paddings = __rest(_c, ["rest"]);
    const _d = extractDimensionProps(withoutPaddings), { rest } = _d, dimensions = __rest(_d, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-title' }, rest, margins, paddings, dimensions, { ref: ref, "$level": level, "$uppercase": uppercase, "$color": _color, "$whiteSpace": whiteSpace, "$textAlign": textAlign, component: levels[level], className: ['tend-ui-typography-title', className].filter(Boolean).join(' ') })));
});
Title.displayName = 'Title';

export { Title };
//# sourceMappingURL=Title.js.map
